<div *ngIf="!loggedIn" class="container center">
    <div class="card">
        <h2>Welcome to SOILGUARDIANS!</h2>
        <hr class="w-full" />
        <p>
            You need to Sign In to access the SOILGUARD data.
        </p>
    </div>
</div>

<div *ngIf="loggedIn">
    <mat-card class="m-8 p-6 my-4 shadow-lg rounded-lg border border-gray-200">
        <div class="text-lg font-semibold text-gray-600 text-center"
            style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
            The Metadata
            Portal allows users to visualize and analyze data generated within the <a href="https://soilguard-h2020.eu/"
                target="_blank" class="text-orange-800 hover:underline hover:pointer-cursor">SOILGUARD</a> project,
            offering
            insights into soil properties, management practices, and indicators. By selecting a parameter from the
            drop-down menu, users can compare datasets across different countries, enabling cross-regional assessments.
        </div>
    </mat-card>
    <mat-card class="m-8 shadow-lg rounded-lg border border-gray-300 my-4">
        <div class="p-4">
            <label for="parameter-select" class="text-gray-800 font-light">
                To visualize data, please select a parameter from the dropdown list.
                You can hover over the graph to see detailed information regarding the values. Additionally, you can
                filter out specific categories by clicking on their names in the legend, allowing for a more
                customized data exploration experience.
            </label>
            <div class="w-1/4 my-2">
                <mat-select id="parameter-select" [(ngModel)]="selectedParameter.key"
                    (selectionChange)="onParameterChange($event)" class="border border-gray-300 rounded p-3">
                    <mat-option *ngFor="let parameter of parameters" [value]="parameter.key">
                        {{ parameter.label }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="flex flex-col justify-center items-center">
                <div *ngIf="chartOptions.length" class="w-3/4 p-2 border border-gray-200 rounded-lg">
                    <div class="w-full text-gray-600 font-medium text-center mt-2">
                        {{ chartOptions[0].title }}
                    </div>
                    <i class="fas fa-info float-right text-lg text-gray-600 cursor-pointer"
                        [matTooltip]="chartOptions[0].tooltip"></i>
                    <div class="w-full flex items-center justify-center">
                        <canvas baseChart [data]="chartOptions[0].config.data"
                            [options]="chartOptions[0].config.options" [type]="chartOptions[0].config.type"></canvas>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>

</div>